import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import InventoryPage from "./InventoryPage";
import OperatingExpensesPage from "./OperatingExpensesPage";
import RefundsPage from "./RefundsPage";
import LoginPage from "./LoginPage";
import PrivateRoute from "../components/common/PrivateRoute";
import { ThemeProvider } from '../components/common/ThemeContext';
import DashboardPage from "./DashboardPage";
import FiguresPage from "./FiguresPage";
import WatchlistPage from "./WatchlistPage";
import OrdersPage from "./OrdersPage";
import UsersPage from "./UsersPage";


function App() {

    return (
        <>
            <ThemeProvider>
                <BrowserRouter>
                    <Routes>
                        <Route index element={<PrivateRoute element={<InventoryPage />} allowedRoles={["ADMIN", "WORKER"]} />} />
                        <Route path="/" element={<PrivateRoute element={<InventoryPage />} allowedRoles={["ADMIN", "WORKER"]} />} />
                        <Route path="/home" element={<PrivateRoute element={<InventoryPage />} allowedRoles={["ADMIN", "WORKER"]} />} />

                        <Route path="/login" element={<LoginPage />}></Route>

                        <Route path="/inventory" element={<PrivateRoute element={<InventoryPage />} allowedRoles={["ADMIN", "WORKER"]} />} />
                        <Route path="/manga" element={<PrivateRoute element={<InventoryPage />} allowedRoles={["ADMIN", "WORKER"]} />} />
                        <Route path="/operating_expenses" element={<PrivateRoute element={<OperatingExpensesPage />} />} />
                        <Route path="/refunds" element={<PrivateRoute element={<RefundsPage />} />} />
                        <Route path="/figures" element={<PrivateRoute element={<FiguresPage />} />} />
                        <Route path="/dashboard" element={<PrivateRoute element={<DashboardPage />} />} />
                        <Route path="/watchlist" element={<PrivateRoute element={<WatchlistPage />} />} />
                        <Route path="/orders" element={<PrivateRoute element={<OrdersPage />} />} />
                        <Route path="/users" element={<PrivateRoute element={<UsersPage />} />} />
                    </Routes>
                    {/*<ScrollToTop />*/}
                </BrowserRouter>
            </ThemeProvider>
        </>
    );
}

export default App;
